import {MetricsClient} from '#/analytics/metrics/client'
import {type Events} from '#/analytics/metrics/types'

export type {Events as Metrics} from '#/analytics/metrics/types'
export * from '#/analytics/metrics/utils'

/**
 * Sunnahsky sends no usage statistics. Upstream's client posts every event to
 * Bluesky's statistics service (events.bsky.app); this one keeps the same type
 * and records nothing, so upstream's client and its tests stay unchanged.
 */
class SilentMetricsClient extends MetricsClient<Events> {
  override start() {}
  override track() {}
  override flush() {}
}

export const metrics: MetricsClient<Events> = new SilentMetricsClient()
